// @flow
'use strict';

import { connect } from 'react-redux';

import ModalCartao from './modal_cartao';

export default connect<*, *, *, *, *, *>()(ModalCartao);
